export default {
  firstName: '',
  lastName: '',
  email: '',
  avatar: '',
  imageBlob: null,
  imageName: ''
}
